import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Input, Radio, Button, message } from "antd";
const { TextArea } = Input;
const API_URL = process.env.REACT_APP_API_URL;

const Response = () => {
  const { conductorId, vehiculoId } = useParams();
  const [questions, setQ] = useState([]);
  const [resp, setR] = useState({});
  
  useEffect(() => {
    fetch(`${API_URL}/pre-operaciones?conductorId=${conductorId}&vehiculoId=${vehiculoId}`)
      .then((r) => r.json())
      .then(setQ)
      .catch(() => message.error("Error"));
  }, [conductorId, vehiculoId]);
  const onChange = (id, v) => setR((p) => ({ ...p, [id]: v }));
  const onMulti = (id, gi, vals) =>
    setR((p) => ({ ...p, [id]: { ...(p[id] || {}), [gi]: vals } }));

  const submit = async () => {
    const respuestas = questions.flatMap((q) =>
      q.tipoRespuesta === "checklist_multiple"
        ? q.descripciones.map((g, gi) => ({
            preguntaId: q.id,
            titulo: `${q.titulo} - ${g.label}`,
            respuesta: resp[q.id]?.[gi] || "",
          }))
        : [{ preguntaId: q.id, titulo: q.titulo, respuesta: resp[q.id] || "" }]
    );
    try {
      const r = await fetch(`${API_URL}/pre-operaciones/generate-pdf`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          conductorId: +conductorId,
          vehiculoId: +vehiculoId,
          respuestas,
        }),
      });
      if (!r.ok) throw new Error("Error al obtener el archivo");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "preoperaciones.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      message.error("Error PDF");
    }
  };
  return (
    <div style={{ padding: 24 }}>
      <h2>PreOperaciones</h2>
      <Form layout="vertical">
        {questions.map((q) => (
          <Form.Item key={q.id} label={q.titulo} required>
            {q.tipoRespuesta === "texto" ? (
              <TextArea
                rows={4}
                value={resp[q.id] || ""}
                onChange={(e) => onChange(q.id, e.target.value)}
              />
            ) : q.tipoRespuesta === "checklist_simple" ? (
              <Radio.Group
                value={resp[q.id]}
                onChange={(e) => onChange(q.id, e.target.value)}
              >
                {q.opciones?.map((o) => (
                  <Radio key={o} value={o}>
                    {o}
                  </Radio>
                ))}
              </Radio.Group>
            ) : (
              q.descripciones?.map((g, gi) => (
                <Form.Item key={gi} label={g.label}>
                  <Radio.Group 
                    options={g.options}
                    value={resp[q.id]?.[gi] || []}
                    onChange={(v) => onMulti(q.id, gi, v)}
                  />
                </Form.Item>
              ))
            )}{" "}
          </Form.Item>
        ))}
        <Form.Item>
          <Button type="primary" onClick={submit}>
            Generar PDF
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default Response;
